/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

@Component({
    template: require('./tipo-ajustes.component.html')
})
export class TipoAjustesComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/tipo-ajustes.component.ts
 **/